(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vantho-accordion-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const GSAP_SOURCE = "https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js";

  const loadGsap = () => {
    if (window.gsap) return Promise.resolve(window.gsap);
    if (window.__vanthoGsapPromise) return window.__vanthoGsapPromise;

    window.__vanthoGsapPromise = new Promise((resolve, reject) => {
      const finish = () => {
        if (window.gsap) resolve(window.gsap);
        else reject(new Error("GSAP blev ikke tilgængelig."));
      };

      const existingScript = document.querySelector("script[data-vantho-gsap]");
      if (existingScript) {
        existingScript.addEventListener("load", finish, { once: true });
        existingScript.addEventListener("error", reject, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = GSAP_SOURCE;
      script.async = true;
      script.dataset.vanthoGsap = "true";
      script.addEventListener("load", finish, { once: true });
      script.addEventListener("error", reject, { once: true });
      document.head.append(script);
    });

    return window.__vanthoGsapPromise;
  };

  class VanthoAccordionGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.panels = Array.from(this.querySelectorAll("[data-vag-panel]"));
      this.targets = this.panels.map((panel) => panel.querySelector("[data-vag-target]"));
      this.media = this.panels.map((panel) => panel.querySelector("[data-vag-media]"));
      this.reveals = this.panels.map((panel) => Array.from(panel.querySelectorAll("[data-vag-reveal]")));

      if (!this.panels.length) return;

      this.activeIndex = this.clampIndex(Number.parseInt(this.dataset.defaultIndex || "0", 10));
      this.expandRatio = this.clamp(Number.parseFloat(this.dataset.expandRatio || "0.52"), 0.2, 0.9);
      this.trigger = this.dataset.trigger || "hover";
      this.duration = Math.max(0, Number.parseFloat(this.dataset.duration || "0.6"));
      this.ease = this.dataset.ease || "power3.out";
      this.parallax = Math.max(0, Number.parseFloat(this.dataset.parallax || "0.5"));
      this.tilt = Math.max(0, Number.parseFloat(this.dataset.tilt || "8"));
      this.stagger = Math.max(0, Number.parseFloat(this.dataset.stagger || "0.06"));
      this.gap = Math.max(0, Number.parseFloat(this.dataset.gap || "10"));
      this.collapsedGray = Number.parseFloat(
        window.getComputedStyle(this).getPropertyValue("--vag-collapsed-gray") || "0",
      );
      this.mobileQuery = window.matchMedia("(max-width: 749px)");
      this.hoverQuery = window.matchMedia("(hover: hover) and (pointer: fine)");
      this.reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.firstRun = true;
      this.mediaSize = 320;

      this.handlePointerOver = (event) => {
        if (this.trigger !== "hover" || this.mobileQuery.matches || !this.hoverQuery.matches) return;
        const panel = event.target.closest("[data-vag-panel]");
        if (!panel || !this.contains(panel)) return;
        this.activate(this.panels.indexOf(panel));
      };

      this.handleFocusIn = (event) => {
        const panel = event.target.closest("[data-vag-panel]");
        if (!panel || !this.contains(panel)) return;
        this.activate(this.panels.indexOf(panel));
      };

      this.handlePointerDown = (event) => {
        if (event.button !== 0) return;
        const panel = event.target.closest("[data-vag-panel]");
        if (!panel || !this.contains(panel)) return;
        this.pointerStartedInactive = this.panels.indexOf(panel) !== this.activeIndex;
        window.clearTimeout(this.pointerResetTimer);
        this.pointerResetTimer = window.setTimeout(() => {
          this.pointerStartedInactive = false;
        }, 1000);
      };

      this.handleClick = (event) => {
        const target = event.target.closest("[data-vag-target]");
        const panel = target?.closest("[data-vag-panel]");
        if (!target || !panel || !this.contains(panel)) return;

        const index = this.panels.indexOf(panel);
        const hasDestination = target.tagName === "A" && target.hasAttribute("href");

        if (index !== this.activeIndex || this.pointerStartedInactive) {
          event.preventDefault();
          window.clearTimeout(this.pointerResetTimer);
          this.pointerStartedInactive = false;
          this.activate(index);
          return;
        }

        window.clearTimeout(this.pointerResetTimer);
        this.pointerStartedInactive = false;
        if (!hasDestination) event.preventDefault();
      };

      this.handleKeyDown = (event) => {
        const target = event.target.closest("[data-vag-target]");
        if (!target || !this.contains(target)) return;

        const index = this.targets.indexOf(target);
        let nextIndex = null;

        if (event.key === "ArrowRight" || event.key === "ArrowDown") nextIndex = index + 1;
        if (event.key === "ArrowLeft" || event.key === "ArrowUp") nextIndex = index - 1;
        if (event.key === "Home") nextIndex = 0;
        if (event.key === "End") nextIndex = this.panels.length - 1;
        if (nextIndex === null) return;

        event.preventDefault();
        const normalizedIndex = (nextIndex + this.panels.length) % this.panels.length;
        this.activate(normalizedIndex);
        this.targets[normalizedIndex]?.focus();
      };

      this.handleViewportChange = () => this.measure(true);
      this.handleReducedMotionChange = () => this.applyLayout(false);
      this.handleBlockSelect = (event) => {
        const blockId = event.detail?.blockId;
        if (!blockId) return;
        const index = this.panels.findIndex((panel) => panel.dataset.blockId === blockId);
        if (index >= 0) this.activate(index);
      };

      this.addEventListener("pointerover", this.handlePointerOver);
      this.addEventListener("pointerdown", this.handlePointerDown);
      this.addEventListener("focusin", this.handleFocusIn);
      this.addEventListener("click", this.handleClick);
      this.addEventListener("keydown", this.handleKeyDown);
      this.mobileQuery.addEventListener("change", this.handleViewportChange);
      this.reducedMotionQuery.addEventListener("change", this.handleReducedMotionChange);
      document.addEventListener("shopify:block:select", this.handleBlockSelect);

      this.resizeObserver = new ResizeObserver(() => this.measure(!this.firstRun));
      this.resizeObserver.observe(this);
      this.measure(false);
      this.firstRun = false;

      loadGsap()
        .then((gsap) => {
          if (!this.isConnected) return;
          this.gsap = gsap;
          this.classList.add("has-gsap");
          this.measure(false);
        })
        .catch(() => {
          if (this.isConnected) this.classList.add("uses-fallback-animation");
        });
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.timeline?.kill();
      window.clearTimeout(this.pointerResetTimer);
      this.resizeObserver?.disconnect();
      this.removeEventListener("pointerover", this.handlePointerOver);
      this.removeEventListener("pointerdown", this.handlePointerDown);
      this.removeEventListener("focusin", this.handleFocusIn);
      this.removeEventListener("click", this.handleClick);
      this.removeEventListener("keydown", this.handleKeyDown);
      this.mobileQuery?.removeEventListener("change", this.handleViewportChange);
      this.reducedMotionQuery?.removeEventListener("change", this.handleReducedMotionChange);
      document.removeEventListener("shopify:block:select", this.handleBlockSelect);
      this.initialized = false;
    }

    clamp(value, minimum, maximum) {
      return Math.min(Math.max(value, minimum), maximum);
    }

    clampIndex(index) {
      if (!Number.isFinite(index)) return 0;
      return this.clamp(index, 0, Math.max(0, this.panels.length - 1));
    }

    activate(index, animate = true) {
      const nextIndex = this.clampIndex(index);
      if (nextIndex === this.activeIndex && !this.firstRun) return;

      this.activeIndex = nextIndex;
      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === nextIndex;
        panel.classList.toggle("is-active", isActive);
        this.targets[panelIndex]?.setAttribute("aria-expanded", isActive ? "true" : "false");
      });

      this.applyLayout(animate);
    }

    measure(animate = true) {
      const rect = this.getBoundingClientRect();
      const vertical = this.mobileQuery.matches;
      const total = vertical ? rect.height : rect.width;
      const usable = Math.max(total - this.gap * (this.panels.length - 1), 120);
      this.mediaSize = Math.max(140, usable * this.expandRatio * 1.22);
      this.style.setProperty("--vag-media-size", `${this.mediaSize}px`);
      this.applyLayout(animate);
    }

    applyLayout(animate = true) {
      if (!this.panels?.length) return;
      if (!this.gsap) {
        this.applyFallbackLayout();
        return;
      }

      const vertical = this.mobileQuery.matches;
      const reducedMotion = this.reducedMotionQuery.matches;
      const duration = animate && !reducedMotion ? this.duration : 0;
      const panelCount = this.panels.length;
      const grow = panelCount > 1 ? (this.expandRatio * (panelCount - 1)) / (1 - this.expandRatio) : 1;

      this.timeline?.kill();
      const timeline = this.gsap.timeline();

      this.panels.forEach((panel, index) => {
        const isActive = index === this.activeIndex;
        const rotation = isActive ? 0 : index < this.activeIndex ? this.tilt : -this.tilt;
        const panelAnimation = {
          flexGrow: isActive ? grow : 1,
          rotateX: vertical ? -rotation : 0,
          rotateY: vertical ? 0 : rotation,
          "--vag-dim": isActive ? 0 : 0.35,
          duration,
          ease: this.ease,
          overwrite: "auto",
        };

        timeline.to(panel, panelAnimation, 0);

        const media = this.media[index];
        if (media) {
          const drift = this.clamp(this.activeIndex - index, -1.5, 1.5);
          const shift = drift * this.parallax * this.mediaSize * 0.06;

          timeline.to(
            media,
            {
              xPercent: -50,
              yPercent: -50,
              x: vertical ? 0 : isActive ? 0 : shift,
              y: vertical ? (isActive ? 0 : shift) : 0,
              "--vag-gray": isActive ? 0 : this.collapsedGray,
              duration,
              ease: this.ease,
              overwrite: "auto",
            },
            0,
          );
        }

        const revealItems = this.reveals[index];
        if (revealItems.length) {
          timeline.to(
            revealItems,
            {
              opacity: isActive ? 1 : 0,
              x: isActive ? 0 : -14,
              duration: isActive ? duration : duration * 0.6,
              ease: this.ease,
              stagger: isActive && !reducedMotion ? this.stagger : 0,
              overwrite: "auto",
            },
            0,
          );
        }
      });

      this.timeline = timeline;
    }

    applyFallbackLayout() {
      const vertical = this.mobileQuery.matches;
      const panelCount = this.panels.length;
      const grow = panelCount > 1 ? (this.expandRatio * (panelCount - 1)) / (1 - this.expandRatio) : 1;

      this.panels.forEach((panel, index) => {
        const isActive = index === this.activeIndex;
        const rotation = isActive ? 0 : index < this.activeIndex ? this.tilt : -this.tilt;
        const drift = this.clamp(this.activeIndex - index, -1.5, 1.5);
        const shift = drift * this.parallax * this.mediaSize * 0.06;
        const media = this.media[index];

        panel.style.flexGrow = isActive ? grow : 1;
        panel.style.setProperty("--vag-dim", isActive ? "0" : "0.35");
        panel.style.transform = vertical ? `rotateX(${-rotation}deg)` : `rotateY(${rotation}deg)`;

        if (media) {
          media.style.setProperty("--vag-gray", isActive ? "0" : String(this.collapsedGray));
          media.style.transform = vertical
            ? `translate(-50%, -50%) translateY(${isActive ? 0 : shift}px)`
            : `translate(-50%, -50%) translateX(${isActive ? 0 : shift}px)`;
        }
      });
    }
  }

  if (!customElements.get("vantho-accordion-gallery")) {
    customElements.define("vantho-accordion-gallery", VanthoAccordionGallery);
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantho-bundle-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(section) {
      if (section.hasAttribute('data-bundle-ready')) return;
      const radios = Array.from(section.querySelectorAll('[data-bundle-radio]'));
      const panels = Array.from(section.querySelectorAll('[data-bundle-panel]'));
      if (!radios.length) return;
      const status = section.querySelector('[data-bundle-status]');
      const selectedRadio = () => radios.find(radio => radio.checked) || radios[0];

      function announce() {
        const panel = panels.find(item => item.id === selectedRadio().value);
        if (!panel || !status) return;
        const price = panel.querySelector('.vantho-bundle-offer__total')?.textContent.trim();
        const availability = panel.querySelector('.vantho-bundle-offer__button:disabled')?.textContent.trim();
        status.textContent = [panel.dataset.bundleLabel, price, availability].filter(Boolean).join('. ');
      }

      function select(radio, direction, moveFocus = false) {
        if (!radio) return;
        radio.checked = true;
        announce();
        if (moveFocus) {
          const panel = panels.find(item => item.id === radio.value);
          panel?.querySelector(`[data-bundle-direction="${direction}"]`)?.focus({ preventScroll: true });
        }
      }

      radios.forEach(radio => radio.addEventListener('change', announce));
      section.querySelectorAll('[data-bundle-direction]').forEach(arrow => {
        const activate = event => {
          event.preventDefault();
          const radio = radios.find(item => item.id === arrow.getAttribute('for'));
          select(radio, arrow.dataset.bundleDirection, true);
        };
        arrow.addEventListener('click', activate);
        arrow.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') activate(event);
        });
      });

      panels.forEach(panel => {
        const products = panel.querySelector('.vantho-bundle-offer__products');
        if (!products || radios.length < 2) return;
        let start = null;
        products.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'touch' || !event.isPrimary) return;
          start = { x: event.clientX, y: event.clientY, id: event.pointerId };
        });
        products.addEventListener('pointercancel', () => { start = null; });
        products.addEventListener('pointerup', event => {
          if (!start || event.pointerId !== start.id) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          start = null;
          if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          const index = radios.indexOf(selectedRadio());
          select(radios[(index + (dx < 0 ? 1 : -1) + radios.length) % radios.length]);
        });
      });

      section.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-bundle-panel]');
        if (panel) select(radios.find(item => item.value === panel.id));
      });
      section.setAttribute('data-bundle-ready', '');
    }

    function initAll(root) {
      if (root.matches?.('.vantho-bundle-offer')) init(root);
      root.querySelectorAll('.vantho-bundle-offer').forEach(init);
    }
    initAll(document);
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
    document.addEventListener('shopify:section:load', event => initAll(event.target));
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vantho-social-dome"] && !Shopify.designMode) return;
  try {
    
(() => {
  class VanthoSocialDome extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.viewport = this.querySelector("[data-vsd-viewport]");
      this.stage = this.querySelector("[data-vsd-stage]");
      this.sphere = this.querySelector("[data-vsd-sphere]");
      this.sources = Array.from(this.querySelectorAll("[data-vsd-source]"));
      this.enlarge = this.querySelector("[data-vsd-enlarge]");
      this.enlargeBackdrop = this.querySelector("[data-vsd-enlarge-backdrop]");
      this.enlargeCard = this.querySelector("[data-vsd-enlarge-card]");
      this.enlargeMedia = this.querySelector("[data-vsd-enlarge-media]");
      this.enlargePlatform = this.querySelector("[data-vsd-enlarge-platform]");
      this.enlargeLink = this.querySelector("[data-vsd-enlarge-link]");
      this.enlargeClose = this.querySelector("[data-vsd-enlarge-close]");

      if (!this.viewport || !this.stage || !this.sphere || !this.sources.length) return;

      this.density = Math.max(this.sources.length, Number.parseInt(this.dataset.density || "60", 10));
      this.desktopRadius = Number.parseFloat(this.dataset.radius || "620");
      this.mobileRadius = Number.parseFloat(this.dataset.mobileRadius || "380");
      this.maxVertical = Math.max(0, Number.parseFloat(this.dataset.maxVertical || "14"));
      this.dragSensitivity = Math.max(4, Number.parseFloat(this.dataset.dragSensitivity || "12"));
      this.autoRotate = this.dataset.autoRotate === "true";
      this.autoSpeed = Number.parseFloat(this.dataset.autoSpeed || "4");
      this.mobileQuery = window.matchMedia("(max-width: 749px)");
      this.reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.rotation = { x: 0, y: 0 };
      this.velocity = { x: 0, y: 0 };
      this.dragging = false;
      this.didDrag = false;
      this.hoveringTile = false;
      this.pointerInside = false;
      this.pointerPoint = null;
      this.hoveredTile = null;
      this.pressedTile = null;
      this.pendingTile = null;
      this.lastFrameTime = performance.now();

      this.buildSphere();
      this.measure();

      this.handlePointerDown = (event) => {
        if (event.button !== 0 || this.enlarged || event.target.closest("[data-vsd-enlarge]")) return;
        this.pressedTile = this.findTileAtPoint(event.clientX, event.clientY);
        this.pendingTile = null;
        this.clearHoveredTile();
        this.dragging = true;
        this.didDrag = false;
        this.pointerId = event.pointerId;
        this.dragStart = {
          x: event.clientX,
          y: event.clientY,
          rotationX: this.rotation.x,
          rotationY: this.rotation.y,
        };
        this.lastPointer = { x: event.clientX, y: event.clientY, time: performance.now() };
        this.velocity = { x: 0, y: 0 };
        this.viewport.setPointerCapture?.(event.pointerId);
      };

      this.handlePointerMove = (event) => {
        this.pointerInside = true;
        this.pointerPoint = {
          x: event.clientX,
          y: event.clientY,
          pointerType: event.pointerType,
        };

        if (!this.dragging) {
          if (event.pointerType === "mouse" || event.pointerType === "pen") {
            this.updateHoveredTile(event.clientX, event.clientY);
          }
          return;
        }

        if (!this.dragging || event.pointerId !== this.pointerId) return;

        const deltaX = event.clientX - this.dragStart.x;
        const deltaY = event.clientY - this.dragStart.y;
        const dragThreshold = event.pointerType === "touch" ? 14 : 8;
        if (!this.didDrag && Math.hypot(deltaX, deltaY) <= dragThreshold) return;
        if (!this.didDrag) {
          this.didDrag = true;
          this.viewport.classList.add("is-dragging");
        }

        this.rotation.y = this.wrapAngle(this.dragStart.rotationY + deltaX / this.dragSensitivity);
        this.rotation.x = this.clamp(
          this.dragStart.rotationX - deltaY / this.dragSensitivity,
          -this.maxVertical,
          this.maxVertical,
        );

        const now = performance.now();
        const elapsed = Math.max(1, now - this.lastPointer.time);
        this.velocity.y = ((event.clientX - this.lastPointer.x) / this.dragSensitivity) / elapsed;
        this.velocity.x = (-(event.clientY - this.lastPointer.y) / this.dragSensitivity) / elapsed;
        this.lastPointer = { x: event.clientX, y: event.clientY, time: now };
        this.render();
      };

      this.handlePointerEnd = (event) => {
        if (!this.dragging || event.pointerId !== this.pointerId) return;
        this.dragging = false;
        this.pendingTile = this.didDrag
          ? null
          : (this.pressedTile || this.findTileAtPoint(event.clientX, event.clientY));
        this.pressedTile = null;
        this.suppressClick = this.didDrag;
        this.viewport.classList.remove("is-dragging");
        if (this.viewport.hasPointerCapture?.(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);

        if (!this.didDrag && (event.pointerType === "mouse" || event.pointerType === "pen")) {
          this.updateHoveredTile(event.clientX, event.clientY);
        }

        window.setTimeout(() => {
          this.suppressClick = false;
        }, 0);
      };

      this.handleClick = (event) => {
        if (event.target.closest("[data-vsd-enlarge]")) return;

        if (this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        const tile = this.pendingTile || this.findTileAtPoint(event.clientX, event.clientY);
        this.pendingTile = null;
        if (!tile) return;

        event.preventDefault();
        event.stopPropagation();
        this.openEnlarged(tile.link);
      };

      this.handleKeyDown = (event) => {
        if (event.key === "Escape" && this.enlarged) {
          event.preventDefault();
          this.closeEnlarged();
          return;
        }
        if (this.enlarged) return;

        const step = event.shiftKey ? 12 : 5;
        if (event.key === "ArrowLeft") this.rotation.y -= step;
        else if (event.key === "ArrowRight") this.rotation.y += step;
        else if (event.key === "ArrowUp") this.rotation.x += step;
        else if (event.key === "ArrowDown") this.rotation.x -= step;
        else if (event.key === "Home") this.rotation = { x: 0, y: 0 };
        else return;

        event.preventDefault();
        this.rotation.x = this.clamp(this.rotation.x, -this.maxVertical, this.maxVertical);
        this.rotation.y = this.wrapAngle(this.rotation.y);
        this.velocity = { x: 0, y: 0 };
        this.render();
      };

      this.handlePointerEnter = (event) => {
        this.pointerInside = true;
        this.pointerPoint = {
          x: event.clientX,
          y: event.clientY,
          pointerType: event.pointerType,
        };

        if (!this.dragging && (event.pointerType === "mouse" || event.pointerType === "pen")) {
          this.updateHoveredTile(event.clientX, event.clientY);
        }
      };

      this.handlePointerLeave = () => {
        this.pointerInside = false;
        this.pointerPoint = null;
        if (!this.dragging) this.clearHoveredTile();
      };

      this.handleViewportChange = () => this.measure();
      this.handleEnlargeClose = () => this.closeEnlarged();
      this.handleEnlargeNavigate = () => {
        window.setTimeout(() => this.closeEnlarged(), 0);
      };
      this.handleEnlargeCardClick = (event) => {
        if (this.openMediaType === "video" || event.target.closest("[data-vsd-enlarge-link]")) return;
        this.enlargeLink?.click();
      };
      this.handleBlockSelect = (event) => {
        const blockId = event.detail?.blockId;
        if (!blockId) return;
        const sourceIndex = this.sources.findIndex((source) => source.dataset.vsdBlockId === blockId);
        if (sourceIndex < 0) return;
        const tile = this.tiles.find((item) => item.sourceIndex === sourceIndex);
        if (!tile) return;
        this.rotation.x = this.clamp(tile.latitude, -this.maxVertical, this.maxVertical);
        this.rotation.y = this.wrapAngle(-tile.longitude);
        this.velocity = { x: 0, y: 0 };
        this.render();
      };

      this.viewport.addEventListener("pointerdown", this.handlePointerDown);
      this.viewport.addEventListener("pointermove", this.handlePointerMove);
      this.viewport.addEventListener("pointerup", this.handlePointerEnd);
      this.viewport.addEventListener("pointercancel", this.handlePointerEnd);
      this.viewport.addEventListener("click", this.handleClick, true);
      this.viewport.addEventListener("keydown", this.handleKeyDown);
      this.viewport.addEventListener("pointerenter", this.handlePointerEnter);
      this.viewport.addEventListener("pointerleave", this.handlePointerLeave);
      this.enlargeBackdrop?.addEventListener("click", this.handleEnlargeClose);
      this.enlargeClose?.addEventListener("click", this.handleEnlargeClose);
      this.enlargeCard?.addEventListener("click", this.handleEnlargeCardClick);
      this.enlargeLink?.addEventListener("click", this.handleEnlargeNavigate);
      this.mobileQuery.addEventListener("change", this.handleViewportChange);
      document.addEventListener("shopify:block:select", this.handleBlockSelect);

      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.viewport);
      this.animationFrame = requestAnimationFrame((time) => this.tick(time));
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      cancelAnimationFrame(this.animationFrame);
      window.clearTimeout(this.closeTimer);
      this.resizeObserver?.disconnect();
      this.viewport?.removeEventListener("pointerdown", this.handlePointerDown);
      this.viewport?.removeEventListener("pointermove", this.handlePointerMove);
      this.viewport?.removeEventListener("pointerup", this.handlePointerEnd);
      this.viewport?.removeEventListener("pointercancel", this.handlePointerEnd);
      this.viewport?.removeEventListener("click", this.handleClick, true);
      this.viewport?.removeEventListener("keydown", this.handleKeyDown);
      this.viewport?.removeEventListener("pointerenter", this.handlePointerEnter);
      this.viewport?.removeEventListener("pointerleave", this.handlePointerLeave);
      this.enlargeBackdrop?.removeEventListener("click", this.handleEnlargeClose);
      this.enlargeClose?.removeEventListener("click", this.handleEnlargeClose);
      this.enlargeCard?.removeEventListener("click", this.handleEnlargeCardClick);
      this.enlargeLink?.removeEventListener("click", this.handleEnlargeNavigate);
      this.mobileQuery?.removeEventListener("change", this.handleViewportChange);
      document.removeEventListener("shopify:block:select", this.handleBlockSelect);
      this.clearHoveredTile();
      this.initialized = false;
    }

    clamp(value, minimum, maximum) {
      return Math.min(Math.max(value, minimum), maximum);
    }

    wrapAngle(value) {
      return ((value + 180) % 360 + 360) % 360 - 180;
    }

    getTileDepth(tile) {
      const latitude = (tile.latitude * Math.PI) / 180;
      const longitude = (tile.longitude * Math.PI) / 180;
      const rotationX = (this.rotation.x * Math.PI) / 180;
      const rotationY = (this.rotation.y * Math.PI) / 180;
      const y = Math.sin(latitude);
      const z = Math.cos(longitude) * Math.cos(latitude);
      const zAfterY = (-Math.sin(longitude) * Math.cos(latitude) * Math.sin(rotationY))
        + (z * Math.cos(rotationY));

      return (y * Math.sin(rotationX)) + (zAfterY * Math.cos(rotationX));
    }

    findTileAtPoint(clientX, clientY) {
      let match = null;
      let matchDepth = -Infinity;

      this.tiles.forEach((tile) => {
        const depth = this.getTileDepth(tile);
        if (depth <= 0.02 || depth <= matchDepth) return;

        const rect = tile.element.getBoundingClientRect();
        const isInside = clientX >= rect.left
          && clientX <= rect.right
          && clientY >= rect.top
          && clientY <= rect.bottom;

        if (isInside) {
          match = tile;
          matchDepth = depth;
        }
      });

      return match;
    }

    updateHoveredTile(clientX, clientY) {
      if (this.dragging || this.enlarged) return;
      const nextTile = this.findTileAtPoint(clientX, clientY);
      if (nextTile === this.hoveredTile) return;

      this.hoveredTile?.link.classList.remove("is-hovered");
      this.hoveredTile = nextTile;
      this.hoveredTile?.link.classList.add("is-hovered");
      this.hoveringTile = Boolean(this.hoveredTile);
      this.viewport.classList.toggle("has-tile-hover", this.hoveringTile);
    }

    clearHoveredTile() {
      this.hoveredTile?.link.classList.remove("is-hovered");
      this.hoveredTile = null;
      this.hoveringTile = false;
      this.viewport?.classList.remove("has-tile-hover");
    }

    openEnlarged(tileLink) {
      if (this.enlarged || !this.enlarge || !this.enlargeCard || !this.enlargeMedia || !this.enlargeLink) return;

      const videoTemplate = tileLink.querySelector("[data-vsd-video-template]");
      const templateVideo = videoTemplate?.content?.querySelector("video");
      const isVideo = tileLink.dataset.vsdMediaType === "video" && Boolean(templateVideo);
      const media = isVideo
        ? templateVideo.cloneNode(true)
        : tileLink.querySelector("img, svg")?.cloneNode(true);
      if (!media) return;

      this.previousFocus = document.activeElement;
      this.openSourceLink = tileLink;
      this.openMediaType = isVideo ? "video" : "image";
      this.enlarged = true;
      this.clearHoveredTile();
      this.hoveringTile = true;
      this.velocity = { x: 0, y: 0 };

      if (!isVideo) {
        media.removeAttribute("loading");
        media.removeAttribute("srcset");
        media.removeAttribute("sizes");
      } else {
        media.controls = true;
        media.playsInline = true;
        media.preload = "metadata";
      }

      this.enlargeMedia.replaceChildren(media);
      this.enlargePlatform.textContent = tileLink.dataset.vsdPlatform || "Social";
      this.enlargeLink.href = tileLink.href;
      this.enlargeLink.setAttribute("aria-label", tileLink.getAttribute("aria-label") || "Åbn socialt opslag");

      if (tileLink.target) this.enlargeLink.target = tileLink.target;
      else this.enlargeLink.removeAttribute("target");
      if (tileLink.rel) this.enlargeLink.rel = tileLink.rel;
      else this.enlargeLink.removeAttribute("rel");

      const viewportRect = this.viewport.getBoundingClientRect();
      const sourceRect = tileLink.getBoundingClientRect();
      const ratio = Math.max(0.55, Math.min(1.15, sourceRect.width / Math.max(1, sourceRect.height)));
      const maxWidth = Math.min(viewportRect.width * 0.84, 560);
      const maxHeight = Math.min(viewportRect.height * 0.82, 700);
      let finalHeight = Math.min(maxHeight, maxWidth / ratio);
      let finalWidth = finalHeight * ratio;

      if (finalWidth > maxWidth) {
        finalWidth = maxWidth;
        finalHeight = finalWidth / ratio;
      }

      this.enlarge.hidden = false;
      this.enlarge.setAttribute("aria-hidden", "false");
      this.enlarge.classList.toggle("has-video", isVideo);
      this.enlarge.classList.remove("is-visible");
      this.enlargeCard.style.left = `${sourceRect.left - viewportRect.left}px`;
      this.enlargeCard.style.top = `${sourceRect.top - viewportRect.top}px`;
      this.enlargeCard.style.width = `${sourceRect.width}px`;
      this.enlargeCard.style.height = `${sourceRect.height}px`;
      this.enlargeCard.style.setProperty("--vsd-enlarge-radius", getComputedStyle(tileLink).borderRadius);
      this.enlarge.offsetWidth;

      if (isVideo) {
        const playback = media.play();
        playback?.catch?.(() => {});
      }

      requestAnimationFrame(() => {
        this.enlarge.classList.add("is-visible");
        this.enlargeCard.style.left = `${(viewportRect.width - finalWidth) / 2}px`;
        this.enlargeCard.style.top = `${(viewportRect.height - finalHeight) / 2}px`;
        this.enlargeCard.style.width = `${finalWidth}px`;
        this.enlargeCard.style.height = `${finalHeight}px`;
        this.enlargeCard.style.setProperty("--vsd-enlarge-radius", "24px");
        window.setTimeout(() => this.enlargeClose?.focus({ preventScroll: true }), 180);
      });
    }

    closeEnlarged(immediate = false) {
      if (!this.enlarged || !this.enlarge) return;

      window.clearTimeout(this.closeTimer);
      this.enlargeMedia?.querySelector("video")?.pause();
      const viewportRect = this.viewport.getBoundingClientRect();
      const sourceRect = this.openSourceLink?.getBoundingClientRect();
      this.enlarge.classList.remove("is-visible");

      if (sourceRect && !immediate) {
        this.enlargeCard.style.left = `${sourceRect.left - viewportRect.left}px`;
        this.enlargeCard.style.top = `${sourceRect.top - viewportRect.top}px`;
        this.enlargeCard.style.width = `${sourceRect.width}px`;
        this.enlargeCard.style.height = `${sourceRect.height}px`;
        this.enlargeCard.style.setProperty("--vsd-enlarge-radius", getComputedStyle(this.openSourceLink).borderRadius);
      }

      const finish = () => {
        this.enlarge.hidden = true;
        this.enlarge.setAttribute("aria-hidden", "true");
        this.enlargeMedia?.replaceChildren();
        this.enlarge.classList.remove("has-video");
        this.enlarged = false;
        this.hoveringTile = false;
        this.openSourceLink = null;
        this.openMediaType = null;
        if (this.previousFocus instanceof HTMLElement && this.previousFocus.isConnected) {
          this.previousFocus.focus({ preventScroll: true });
        }
      };

      if (immediate || this.reducedMotionQuery.matches) finish();
      else this.closeTimer = window.setTimeout(finish, 380);
    }

    buildSphere() {
      const goldenAngle = Math.PI * (3 - Math.sqrt(5));
      this.tiles = [];
      this.sphere.replaceChildren();

      for (let index = 0; index < this.density; index += 1) {
        const sourceIndex = index % this.sources.length;
        const source = this.sources[sourceIndex];
        const y = 1 - ((index + 0.5) * 2) / this.density;
        const latitude = Math.asin(y) * (180 / Math.PI);
        const longitude = ((index * goldenAngle * 180) / Math.PI) % 360;
        const shell = document.createElement("div");
        const link = source.cloneNode(true);

        shell.className = "vsd_tile";
        shell.style.transform = `rotateY(${longitude}deg) rotateX(${-latitude}deg) translateZ(var(--vsd-radius))`;
        link.className = "vsd_tile_link";
        link.removeAttribute("data-vsd-source");
        link.removeAttribute("data-vsd-block-id");
        link.removeAttribute("data-shopify-editor-block");
        link.tabIndex = -1;
        link.querySelectorAll("img").forEach((image) => {
          image.draggable = false;
        });

        shell.append(link);
        this.sphere.append(shell);
        this.tiles.push({ element: shell, link, latitude, longitude, sourceIndex });
      }
    }

    measure() {
      const radius = this.mobileQuery.matches ? this.mobileRadius : this.desktopRadius;
      const tileWidth = this.clamp(radius * 0.25, this.mobileQuery.matches ? 82 : 104, this.mobileQuery.matches ? 122 : 168);
      const tileHeight = tileWidth * 1.24;

      this.radius = radius;
      this.style.setProperty("--vsd-radius", `${radius}px`);
      this.style.setProperty("--vsd-tile-width", `${tileWidth}px`);
      this.style.setProperty("--vsd-tile-height", `${tileHeight}px`);
      this.tiles.forEach((tile) => {
        tile.element.style.width = `${tileWidth}px`;
        tile.element.style.height = `${tileHeight}px`;
        tile.element.style.marginLeft = `${-tileWidth / 2}px`;
        tile.element.style.marginTop = `${-tileHeight / 2}px`;
      });
      this.stage.style.perspective = `${radius * 2.1}px`;
      this.render();
    }

    render() {
      this.sphere.style.transform = `translateZ(${-this.radius}px) rotateX(${this.rotation.x}deg) rotateY(${this.rotation.y}deg)`;
    }

    tick(time) {
      const elapsed = Math.min(40, Math.max(0, time - this.lastFrameTime));
      this.lastFrameTime = time;
      const reduceMotion = this.reducedMotionQuery.matches;

      if (!this.dragging && !reduceMotion) {
        const hasInertia = Math.abs(this.velocity.x) > 0.0004 || Math.abs(this.velocity.y) > 0.0004;

        if (hasInertia) {
          this.rotation.x = this.clamp(
            this.rotation.x + this.velocity.x * elapsed,
            -this.maxVertical,
            this.maxVertical,
          );
          this.rotation.y = this.wrapAngle(this.rotation.y + this.velocity.y * elapsed);
          const damping = Math.pow(0.91, elapsed / 16.67);
          this.velocity.x *= damping;
          this.velocity.y *= damping;
          this.render();
        } else if (this.autoRotate && !this.hoveringTile) {
          this.rotation.y = this.wrapAngle(this.rotation.y + (this.autoSpeed * elapsed) / 1000);
          this.render();
        }
      }

      if (
        this.pointerInside
        && this.pointerPoint
        && !this.dragging
        && !this.enlarged
        && (this.pointerPoint.pointerType === "mouse" || this.pointerPoint.pointerType === "pen")
      ) {
        this.updateHoveredTile(this.pointerPoint.x, this.pointerPoint.y);
      }

      this.animationFrame = requestAnimationFrame((nextTime) => this.tick(nextTime));
    }
  }

  if (!customElements.get("vantho-social-dome")) {
    customElements.define("vantho-social-dome", VanthoSocialDome);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
